import Input from '@/components/Input';
import { FiSearch } from '@/components/react-icons/main/index.esm';
import setQuery from '@/lib/setQuery';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors';

const DetailsSearch = () => {
  const searchValue = decodeURIComponent(useArgSelector(selectors.query, 'detailsSearch') || '').replace(/\+/g, ' ');

  const handleSearch = (e) => {
    setQuery({ detailsSearch: e.target.value || null });
  };

  return (
    <Input //
      className="details-search"
      size="lg"
      icon={FiSearch}
      value={searchValue}
      onChange={handleSearch}
      placeholder="Search in this log"
    />
  );
};

export default DetailsSearch;
